import React, { useEffect, useState } from 'react';
import config from 'config';
import { getZoomSessionSignature } from '../../ApiUtil';
import Utils from '../../Utils';

const getLastPathSegment = (url) => {
    const pathname = new URL(url).pathname;
    var parts = pathname.split('/');
    var lastPart = parts[parts.length - 1];

    return lastPart;
};

const ZoomEmbed = ({ participantUrl, me, accountId, eventId, sessionId }) => {
    const meetingNumber = getLastPathSegment(participantUrl);
    const password = participantUrl.split('pwd=')[1];

    const [signature, setSignature] = useState(false);

    useEffect(() => {
        getZoomSessionSignature({
            accountId,
            eventId,
            sessionId,
            meetingId: meetingNumber,
        }).then(({ token }) => {
            setSignature(token);
        }).catch((error) => {
            console.error('Error while generating zoom signature', error);
        });
    }, []);

    if (!signature) {
        return null;
    }

    const zoomUrl = `https://cdn-static.bizzabo.com/webzoomembed/${config.zoomEmbedVersion}/index.html`;

    const zoomParams = new URLSearchParams({
        meetingNumber,
        password,
        signature,
        userName: Utils.getFullName(me.firstName, me.lastName) || 'Attendee',
        sdkKey: config.zoomClientKey,
    });

    return (
        <iframe
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            id='zmmtg-container'
            src={`${zoomUrl}?${zoomParams.toString()}`}
            allow='camera; microphone; screen-wake-lock; fullscreen; cross-origin-isolated; display-capture'
        />
    );
};

export default ZoomEmbed;
